import { useState } from 'react';
import { Row, Col, Card, CardBody, CardHeader, Collapse, Button } from 'reactstrap';
import { FaChevronUp, FaChevronDown, FaChevronRight, FaFileUpload } from 'react-icons/fa';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Tooltip as ReactTooltip } from "react-tooltip";
import useLocalStorage from "../Utilities/Hooks/useLocalStorage";

const MapImport = ({ importShapeFilesClick }) => {
    const [roleName, setRoleName] = useState(localStorage.getItem("roleName"));
    const [farmRoleName, setFarmRoleName] = useLocalStorage('farmRoleName', null);
    const [isOpen, setIsOpen] = useState(false);
    const [isIconUp, setIsIconUp] = useState(false);

    const toggle = () => {
        setIsOpen(!isOpen)
        setIsIconUp(!isIconUp)
    };

    const CustomToastWithLink = () => (
        <div>
            <p>If you have a .kml file of the farm boundary save it to a convenient location on your computer. Click on the import files icon and then click on the Upload KML file icon. Browse your computer to find your file and click Open.</p>
        </div>
    );
    const customId = "custom-id-yes";
    const showToastMessage = (e) => {
        e.stopPropagation();
        toast.info(CustomToastWithLink, {
            autoClose: false, theme: "colored", hideProgressBar: true, icon: false, toastId: customId, rtl: false
        });
    };

    return (
        <Card>
            <CardHeader className="item-header item_click" onClick={toggle}>
                <Row>
                    <Col sm="11">
                        <h5 className="color-dark-teal">Map Import&nbsp;&nbsp;&nbsp;
                            <img className="featureIcon" src="/images/info_button_lt.png" data-tooltip-id="my-tooltip-2" onClick={(e) => e.stopPropagation()} /></h5>
                            <ReactTooltip opacity="1" className="overrideMe" globalCloseEvents={{ escape: true, clickOutsideAnchor: true, scroll: true, resize: true }} openOnClick="true" clickable="true" style={{ marginTop: "-1vh", backgroundColor: "#e2f2f3", color: "black", maxWidth: "25vw", fontWeight: "750", wordBreak: 'normal', overflowWrap: 'break-word' }}
                                id="my-tooltip-2"
                                place="top"
                                variant="info"
                                render={({ content, activeAnchor }) => (
                                    <>
                                        <Row>
                                            <Col>
                                                <p style={{ fontWeight: "lighter" }}>
                                                    For more information on how to import a map <a href="https://freshwaterfarmplan.co.nz/fwfp-support/importing-map-boundaries/" target="_blank" rel="noreferrer">Click Here</a>
                                                </p>
                                            </Col>
                                        </Row>
                                    </>
                                )}
                            />
                    </Col>
                    <Col sm="1" style={{ marginLeft: "auto", marginRight: "5px" }} className="toggleoutline">
                            {isIconUp ? <FaChevronUp /> : <FaChevronDown />}
                    </Col>
                </Row>
            </CardHeader>
            <Collapse isOpen={isOpen}>
                <CardBody>
                    <Row>
                        <Col>
                            <div className="panel-group" id="accordion-Edit" role="tablist" aria-multiselectable="true">
                                <Row>
                                    <Col sm="8">
                                        <label className="kmlLabel para-light-sm"> If you have an existing maps of the farm it is easy to import.</label> <br /><br />
                                        <label className="kmlLabel para-light-sm"> Any number of layers can be imported including</label><br />
                                        <label className="kmlAdvanceLabel">  - Boundary/Outline</label><br />
                                        <label className="kmlAdvanceLabel">  - Land Units</label><br />
                                        <label className="kmlAdvanceLabel">  - Infrastructure</label><br />
                                        <label className="kmlAdvanceLabel">  - Waterways</label>
                                    </Col>
                                    <Col sm="4">
                                        {(roleName == 'SWNZ Admin' || farmRoleName == 'SWNZ Admin' || farmRoleName == 'Manager') &&
                                            <>
                                            <Button style={{ float: "right", marginLeft: "auto", marginRight: "-5px" }} className="btn-next-page float-end" onClick={importShapeFilesClick}> Import Files <FaFileUpload style={{ height: "1.25em", width: "1.25em" }} /> </Button>
                                            </>
                                        }
                                    </Col>
                                </Row>
                                <label className="kmlLabel para-light-sm">  Once imported the shapes and items are independent from the source and can be managed from the FWFP system.</label>
                                <label className="kmlLabel para-light-sm"> ✦ Maps must be KML format to upload. Other files types can be easily converted. Please contact support if you need help.</label>
                            </div>
                        </Col>
                    </Row>
                </CardBody>
            </Collapse>
        </Card>
    );
}
export default MapImport